import React from 'react';
import { makeStyles } from 'tss-react/mui';

import {
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  units,
} from '@hbf/dsl';

import { useIntl } from 'ha/i18n';

const useStyles = makeStyles()(theme => ({
  defaultValueOption: {
    display: 'none',
  },
  durationSelect: {
    marginTop: units.rem(1),
    [theme.breakpoints.up('md')]: {
      marginTop: units.rem(0),
    },
  },
}));

interface Props {
  duration?: number;
  onChange: (duration: number) => void;
}

export const AvailabilityDuration: React.FC<Props> = ({
  duration,
  onChange,
}) => {
  const { T } = useIntl();
  const { classes } = useStyles();

  const renderMenuItems = (month: number) => {
    const text = month === 1 ? T('%d month', 1) : T('%d months', month);

    return (
      <MenuItem key={month} value={month}>
        {text}
      </MenuItem>
    );
  };

  const handleSelectChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(Number(e.target.value));
    },
    [onChange],
  );

  return (
    <Grid item className={classes.durationSelect}>
      <FormControl margin="dense" fullWidth>
        <InputLabel
          id="select-label-duration"
          data-test-locator="availability-duration"
        >
          {T('search.filters.duration.title')}
        </InputLabel>
        <Select
          labelId="select-label-duration"
          value={duration || ''}
          margin="dense"
          onChange={handleSelectChange}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          }}
        >
          <MenuItem value={0} disabled className={classes.defaultValueOption}>
            {T('search.filters.duration.placeholder')}
          </MenuItem>
          {[...Array(12)].map((_, month) => renderMenuItems(month + 1))}
        </Select>
      </FormControl>
    </Grid>
  );
};
